import { translate } from "@/utils/format";

// Getters so the text follows the current language when read.
export const LANG = {
    get LANG_REFERRAL_TITLE() {
        return translate("LANG_REFERRAL_TITLE", "Tu cuenta en Caloo|Oorenji");
    },
    get LANG_REFERRAL_CODE_LABEL() {
        return translate("LANG_REFERRAL_CODE_LABEL", "Tu código de referido");
    },
    get LANG_REFERRAL_LINK_LABEL() {
        return translate("LANG_REFERRAL_LINK_LABEL", "Tu enlace de referido");
    },
    get LANG_EDIT_CODE() {
        return translate("LANG_EDIT_CODE", "Editar código");
    },
    get LANG_UPDATE_CODE_BTN() {
        return translate("LANG_UPDATE_CODE_BTN", "Actualizar código");
    },
    get LANG_CANCEL_BTN() {
        return translate("LANG_CANCEL_BTN", "Cancelar");
    },
    get LANG_COPY_LINK() {
        return translate("LANG_COPY_LINK", "Copiar enlace");
    },
    get LANG_DOWNLOAD_QR() {
        return translate("LANG_DOWNLOAD_QR", "Descargar QR");
    },
    get LANG_STRIPE_TITLE() {
        return translate("LANG_STRIPE_TITLE", "Stripe Connect");
    },
    get LANG_STRIPE_NOT_CONNECTED() {
        return translate("LANG_STRIPE_NOT_CONNECTED", "Aún no has conectado tu cuenta de Stripe.");
    },
    get LANG_STRIPE_PENDING() {
        return translate("LANG_STRIPE_PENDING", "Configura tu perfil de pagos con Stripe.");
    },
    get LANG_STRIPE_READY() {
        return translate("LANG_STRIPE_READY", "Tu cuenta de Stripe está lista.");
    },
    get LANG_STRIPE_CREATED() {
        return translate("LANG_STRIPE_CREATED", "Cuenta de Stripe creada. Completa el onboarding.");
    },
    get LANG_STRIPE_CONNECTED() {
        return translate("LANG_STRIPE_CONNECTED", "Cuenta de Stripe conectada correctamente ✅");
    },
    get LANG_STRIPE_LINK_EXPIRED() {
        return translate("LANG_STRIPE_LINK_EXPIRED", "El enlace ha caducado, genera uno nuevo ⚠️");
    },
    get LANG_STRIPE_CHECK_STATUS() {
        return translate("LANG_STRIPE_CHECK_STATUS", "Comprobar estado");
    },
    get LANG_STRIPE_ONBOARDING() {
        return translate("LANG_STRIPE_ONBOARDING", "Completar perfil de Stripe");
    },
    get LANG_STRIPE_CREATE_ACCOUNT() {
        return translate("LANG_STRIPE_CREATE_ACCOUNT", "Crear cuenta");
    },
    get LANG_STRIPE_READY_SNACK() {
        return translate("LANG_STRIPE_READY_SNACK", "Stripe listo ✅");
    },
    get LANG_STRIPE_PENDING_SNACK() {
        return translate("LANG_STRIPE_PENDING_SNACK", "Stripe pendiente ⏳");
    },
    get LANG_COPY_SUCCESS() {
        return translate("LANG_COPY_SUCCESS", "Enlace copiado");
    },
    get LANG_SUCCESS_UPDATE_CODE() {
        return translate("LANG_SUCCESS_UPDATE_CODE", "Código actualizado");
    },
    get LANG_ERROR_CODE_EXISTS() {
        return translate("LANG_ERROR_CODE_EXISTS", "Ese código ya está en uso, prueba otro");
    },
    get LANG_PROFILE() {
        return translate("LANG_PROFILE", "Mi perfil");
    },
    get LANG_DASHBOARD_TITLE() {
        return translate("LANG_DASHBOARD_TITLE", "Tu rendimiento");
    },
    get LANG_METRIC_INSTALLS() {
        return translate("LANG_METRIC_INSTALLS", "Instalaciones");
    },
    get LANG_METRIC_SUBSCRIBERS() {
        return translate("LANG_METRIC_SUBSCRIBERS", "Suscriptores");
    },
    get LANG_PRODUCTS_TITLE() {
        return translate("LANG_PRODUCTS_TITLE", "Productos para compartir");
    },
    get LANG_PRODUCTS_COPY() {
        return translate("LANG_PRODUCTS_COPY", "Copiar link");
    },
    get LANG_PRODUCTS_COPIED() {
        return translate("LANG_PRODUCTS_COPIED", "Link copiado ✅");
    },
    get LANG_PROFILE_UPDATED() {
        return translate("LANG_PROFILE_UPDATED", "Perfil actualizado");
    },
    get LANG_GO_PANEL() {
        return translate("LANG_GO_PANEL", "Ir al panel de Stripe");
    },
};
